import { inject, Service } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, zip } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { FoodbackAccountContext } from '@core/classes/account/account-context.class';
import { AccountService } from '@core/providers/account/account.service';
import { ContextService } from '@core/providers/context/context.service';
import { ContextObject } from '@shared/interfaces/login-object';

@Service()
export class GoalsGuard {
  private accountService = inject(AccountService);
  private contextService = inject(ContextService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return zip(
      this.accountService.getAccountContext$().pipe(first()),
      this.contextService.getContext$()
    ).pipe(
      map(([account, context]: [FoodbackAccountContext, ContextObject]) =>
        ContextService.isAccountContext(context)
      )
    );
  }
}
